import type { ReactNode } from 'react';
import { Logo } from '@/layout/Logo';
import styles from './AuthLayout.module.css';

/** Centered card for the public pages (login, accept invite). */
export function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <main className={styles.page}>
      <div className={styles.card}>
        <Logo className={styles.logo} />
        <div className={styles.heading}>
          <h1>{title}</h1>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
        {children}
      </div>
      {footer && <p className={styles.footer}>{footer}</p>}
    </main>
  );
}
